import React from 'react'
import { isUgcCreatorTag } from '../../utils/tagStyles'

export const tagChipClasses = tag => {
  if (isUgcCreatorTag(tag)) return 'bg-purple-600/15 text-purple-700 dark:text-purple-300'
  if (tag?.campaign_id) return 'bg-amber-400/20 text-amber-700 dark:text-amber-300'
  return 'bg-blue-600/10 text-blue-700 dark:text-blue-300'
}

export default function TagChip({ tag }) {
  const ugc = isUgcCreatorTag(tag)

  return (
    <span
      title={ugc ? 'UGC creator' : tag.campaign_id ? 'Campaign tag' : undefined}
      className={`inline-flex items-center h-6 px-2.5 rounded-full text-xs font-semibold whitespace-nowrap ${tagChipClasses(tag)}`}
    >
      {ugc ? `★ ${tag.name}` : tag.name}
    </span>
  )
}
